import Vue from "vue";
import router from "./article/router"

window.addEventListener('load', function () {
	new Vue({
		router,
		el: '#vue',
		template: '<router-view></router-view>'
	});
});


// WEBPACK FOOTER //
// ./src/article.js